module.exports = __webpack_public_path__ + "static/media/ab_color.10192cc8.jpg";